import searchApi from '../apis/search'
import userApi from '../apis/user'

const state = {
  tabIndex: 0,
  keyW: '',
  gifts: {
    keyW: '',
    status: [
      {
        value: 'ongoing',
        label: '上架中'
      },
      {
        value: 'finish',
        label: '已送出'
      },
      {
        value: 'pull_off',
        label: '已下架'
      }
    ],
    list: {},
    isLoading: false
  },
  flashes: {
    keyW: '',
    status: [
      {
        value: 'ongoing',
        label: '上架中'
      },
      {
        value: 'finish',
        label: '已送出'
      },
      {
        value: 'pull_off',
        label: '已下架'
      }
    ],
    list: {},
    isLoading: false
  },
  needs: {
    keyW: '',
    status: [
      {
        value: 'ongoing',
        label: '募集中'
      },
      {
        value: 'finish',
        label: '已完成'
      },
      {
        value: 'pull_off',
        label: '已下架'
      }
    ],
    list: {},
    isLoading: false
  },
  members: {
    keyW: '',
    status: [
      {
        value: 'carbon',
        label: '企業/組織'
      },
      {
        value: 'user',
        label: '會員'
      }
    ],
    list: {},
    isLoading: false
  },
  loveboxs: {
    keyW: '',
    status: [
      {
        value: 1,
        label: '上架中'
      },
      {
        value: 3,
        label: '已送出'
      },
      {
        value: 2,
        label: '已送出'
      }
    ],
    list: {},
    isLoading: false
  },
  stories: {
    keyW: '',
    data: [],
    currentPage: 0,
    total: 0,
    lastPage: 1,
    isLoading: false
  },
  loveboxItems: [],
  hotGifts: {
    data: [],
    currentPage: 0,
    lastPage: 1,
    isLoading: false,
    total: 0
  }
}

const actions = {
  searchGift ({commit, state}, {keyW, page, category, cb}) {
    let status = ''
    if (page === 1) {
      status = state.gifts.status[0].value
    } else {
      for (const item of state.gifts.status) {
        if (!state.gifts.list[item.value]) {
          status = item.value
          page = 1
          break
        }

        const data = state.gifts.list[item.value]
        if (data.currentPage + 1 <= data.lastPage) {
          page = data.currentPage + 1
          status = item.value
          break
        }
      }
    }

    if (!status || !keyW) {
      return
    }

    commit('setSearchLoading', { type: 'gifts', loading: true })
    searchApi.searchGift(
      keyW,
      page,
      status,
      category,
      (data) => {
        cb(data)
        if (data) {
          commit('setSearchGifts', { status, data })
        }
      }
    )
  },
  searchFlash ({commit, state}, {keyW, page, category, cb}) {
    let status = ''
    if (page === 1) {
      status = state.flashes.status[0].value
    } else {
      for (const item of state.flashes.status) {
        if (!state.flashes.list[item.value]) {
          status = item.value
          page = 1
          break
        }

        const data = state.flashes.list[item.value]
        if (data.currentPage + 1 <= data.lastPage) {
          page = data.currentPage + 1
          status = item.value
          break
        }
      }
    }

    if (!status || !keyW) {
      return
    }

    commit('setSearchLoading', { type: 'flashes', loading: true })
    searchApi.searchFlash(
      keyW,
      page,
      status,
      category,
      (data) => {
        cb(data)
        if (data) {
          commit('setSearchFlashes', { status, data })
        }
      }
    )
  },
  searchNeed ({commit, state}, {keyW, page, category, cb}) {
    let status = ''
    if (page === 1) {
      status = state.needs.status[0].value
    } else {
      for (const item of state.needs.status) {
        if (!state.needs.list[item.value]) {
          status = item.value
          page = 1
          break
        }

        const data = state.needs.list[item.value]
        if (data.currentPage + 1 <= data.lastPage) {
          page = data.currentPage + 1
          status = item.value
          break
        }
      }
    }
    if (!status || !keyW) {
      return
    }

    commit('setSearchLoading', { type: 'needs', loading: true })
    searchApi.searchNeed(
      keyW,
      page,
      status,
      category,
      (data) => {
        if (data) {
          commit('setSearchNeeds', { status, data })
        }
        cb(data)
      }
    )
  },
  searchMember ({commit, state}, {keyW, page, category, cb}) {
    let status = ''
    if (page === 1) {
      status = state.members.status[0].value
    } else {
      for (const item of state.members.status) {
        if (!state.members.list[item.value]) {
          status = item.value
          page = 1
          break
        }

        const data = state.members.list[item.value]
        if (data.currentPage + 1 <= data.lastPage) {
          page = data.currentPage + 1
          status = item.value
          break
        }
      }
    }

    if (!status || !keyW) {
      return
    }

    commit('setSearchLoading', { type: 'members', loading: true })
    if (status === 'user') {
      searchApi.searchMember(
        keyW,
        page,
        category,
        (data) => {
          if (data) {
            commit('setSearchMembers', { status, data })
          }
          cb(data)
        }
      )
    } else if (status === 'carbon') {
      searchApi.searchCarbonLabelling(keyW, page, 20)
        .then((res) => {
          commit('setSearchMembers', { status, data: res.data })
          cb(res.data)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  searchMemberWithUserId ({commit}, {keyW, cb}) {
    commit('setSearchLoading', { type: 'members', loading: true })
    userApi.getUserInfo(
      keyW,
      (res) => {
        const resObj = {data: res}
        commit('setSearchMemberWithUserId', res)
        cb(resObj)
      }
    )
  },
  searchLovebox ({commit, state}, {keyW, page, category, cb}) {
    let status = ''
    if (page === 1) {
      status = state.loveboxs.status[0].value
    } else {
      for (const item of state.loveboxs.status) {
        if (!state.loveboxs.list[item.value]) {
          status = item.value
          page = 1
          break
        }

        const data = state.loveboxs.list[item.value]
        if (data.currentPage + 1 <= data.lastPage) {
          page = data.currentPage + 1
          status = item.value
          break
        }
      }
    }
    if (!status || !keyW) {
      return
    }

    commit('setSearchLoading', { type: 'loveboxs', loading: true })
    searchApi.searchLovebox(
      keyW,
      page,
      status,
      category,
      (data) => {
        if (data) {
          commit('setSearchLovebox', { status, data })
        }
        cb(data)
      }
    )
  },
  searchStories ({ commit, state }, { keyW, page, category, cb }) {
    if (!keyW) {
      return
    }

    if (!page) {
      page = state.stories.currentPage + 1
    }

    commit('setSearchLoading', { type: 'stories', loading: true })
    searchApi.searchStories(
      keyW,
      page,
      category,
      (data) => {
        if (data) {
          commit('setSearchStories', {data})
        }
        cb(data)
      }
    )
  },
  searchLoveboxAtGiftPool ({ commit }, { keyW, page, perPage }) {
    if (!keyW) {
      return
    }
    return searchApi.searchLovebox2(keyW, page, perPage, 1)
      .then((data) => {
        commit('setSearchLoveboxItems', {data})
      })
  },
  getHotGiftList ({ commit }, { page, perPage }) {
    return searchApi.getHotGiftList(page, perPage)
      .then((data) => {
        commit('setHotGiftList', { data })
      })
  }
}

const mutations = {
  setSearchGifts (state, { status, data }) {
    state.gifts.list[status] = {
      data: data.current_page === 1 ? data.data : [...state.gifts.list[status].data, ...data.data],
      currentPage: data.current_page,
      total: data.total,
      lastPage: data.last_page
    }
    state.gifts.list = {
      ...state.gifts.list
    }
    state.gifts.isLoading = false
  },
  setSearchFlashes (state, { status, data }) {
    state.flashes.list[status] = {
      data: data.current_page === 1 ? data.data : [...state.flashes.list[status].data, ...data.data],
      currentPage: data.current_page,
      total: data.total,
      lastPage: data.last_page
    }
    state.flashes.list = {
      ...state.flashes.list
    }
    state.flashes.isLoading = false
  },
  setSearchNeeds (state, { status, data }) {
    state.needs.list[status] = {
      data: data.current_page === 1 ? data.data : [...state.needs.list[status].data, ...data.data],
      currentPage: data.current_page,
      total: data.total,
      lastPage: data.last_page
    }
    state.needs.list = {
      ...state.needs.list
    }
    state.needs.isLoading = false
  },
  setSearchMembers (state, { status, data }) {
    state.members.list[status] = {
      data: data.current_page === 1 ? data.data : [...state.members.list[status].data, ...data.data],
      currentPage: data.current_page,
      total: data.total,
      lastPage: data.last_page
    }
    state.members.list = {
      ...state.members.list
    }
    state.members.isLoading = false
  },
  setSearchMemberWithUserId (state, res) {
    const newUsers = {
      ...res,
      nickname: (res.nickname && res.nickname.replace(/null/i, '暫無')) || '暫無'
    }

    state.members.list['user'] = {
      currentPage: 1,
      data: res.error ? [] : Array(newUsers),
      total: 1,
      lastPage: res.error ? 0 : 1
    }
    state.members.list = {
      ...state.members.list
    }
    state.members.isLoading = false
  },
  setSearchLovebox (state, { status, data }) {
    state.loveboxs.list[status] = {
      data: data.current_page === 1 ? data.data : [...state.loveboxs.list[status].data, ...data.data],
      currentPage: data.current_page,
      total: data.total,
      lastPage: data.last_page
    }
    state.loveboxs.list = {
      ...state.loveboxs.list
    }
    state.loveboxs.isLoading = false
  },
  setSearchStories (state, {data}) {
    state.stories = {
      ...state.stories,
      data: data.current_page === 1 ? data.data : [...state.stories.data, ...data.data],
      currentPage: data.current_page,
      total: data.total,
      lastPage: data.last_page,
      isLoading: false
    }
  },
  setSearchLoading (state, { type, loading }) {
    state[type].isLoading = loading
  },
  setSearchKeyW (state, {keyW}) {
    state.keyW = keyW
  },
  setTypeKeyW (state, {type, keyW}) {
    state[type].keyW = keyW
  },
  setSearchTabIndex (state, {index}) {
    state.tabIndex = index
  },
  initSearch (state, {type}) {
    if (state[type].data) {
      state[type] = {
        ...state[type],
        data: [],
        currentPage: 0,
        total: 0,
        lastPage: 1,
        isLoading: false
      }
    } else if (state[type].list) {
      state[type] = {
        ...state[type],
        list: {},
        isLoading: false
      }
    }

    if (type === 'gifts') {
      state.loveboxItems = []
    }
  },
  clearSearch (state, {type}) {
    if (state[type].data) {
      state[type] = {
        ...state[type],
        data: [],
        currentPage: 1,
        total: 0,
        lastPage: 1,
        isLoading: false
      }
    } else if (state[type].list) {
      let list = {}
      for (const item of state[type].status) {
        list[item.value] = {
          data: [],
          currentPage: 1,
          total: 0,
          lastPage: 1
        }
      }
      state[type] = {
        ...state[type],
        list,
        isLoading: false
      }
    }

    if (type === 'gifts') {
      state.loveboxItems = []
    }
  },
  setSearchLoveboxItems (state, { data }) {
    state.loveboxItems = data.data
  },
  setHotGiftList (state, { data }) {
    state.hotGifts = {
      currentPage: data.current_page,
      lastPage: data.last_page,
      total: data.total,
      data: data.current_page === 1 ? data.data : [...state.hotGifts.data, ...data.data],
      isLoading: false
    }
  }
}

export default{
  state,
  actions,
  mutations
}
